var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('Header',{attrs:{"title":"Om NetsGo","description":"Begynn en samtale med oss og finn ditt behov, vi hjelper deg på veien til å transformere din bedrift."}}),_c('AboutSection'),_c('Team')],1)}
var staticRenderFns = []

export { render, staticRenderFns }